<template>
  <div id="login">
    <h3 class="login-title van-hairline--top-bottom">登录</h3>
    <van-cell-group v-show="index !== 1">
      <van-field
        v-model="mobile"
        required
        label="手机号"
        placeholder="请输入手机号"
      ></van-field>
      <van-field
        v-model="code"
        required
        label="验证码"
        placeholder="请输入验证码"
      >
        <van-button
          slot="button"
          :disabled="codeDisabled"
          size="small"
          type="primary"
          @click="getCode"
        >
          发送验证码{{ count }}
        </van-button>
      </van-field>
    </van-cell-group>
    <van-cell-group v-show="index === 1">
      <van-field
        v-model="mobile"
        required
        label="手机号"
        placeholder="请输入手机号"
      ></van-field>
      <van-field
        v-model="password"
        type="password"
        required
        label="密码"
        placeholder="请输入密码"
      >
        <van-button
          slot="button"
          :disabled="codeDisabled"
          size="small"
          type="primary"
          @click="toForgot"
        >
          忘记密码
        </van-button>
      </van-field>
    </van-cell-group>
    <van-row style="margin:0.25rem;font-size: 0.375rem;color: #0b92e6;"
      ><span @click="tabsChange">{{
        index === 1 ? "验证码登录" : "密码登录"
      }}</span>
    </van-row>
    <div class="btn">
      <van-button
        type="danger"
        plain
        size="normal"
        @click="toRegister"
        v-show="index === 1"
        >立即注册</van-button
      >
      <van-button type="danger" size="normal" @click="login">登录</van-button>
    </div>
    <div
      v-show="index !== 1"
      style=" height: 2rem; line-height:2rem; font-size:0.4rem;text-align:center;"
    >
      <span style="color:red;">*</span>未注册的用户登录默认为云企物流注册会员
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  name: "Login",
  data() {
    return {
      userId: "",
      // 手机号
      mobile: "",
      // 密码
      password: "",
      // 验证码
      code: "",
      // 标签页索引
      index: 2,
      // 发送验证码不可用
      codeDisabled: false,
      // 验证码倒计时
      count: "",
      // 计时器
      timer: null,
      //标记云企、河北云企
      mark: 'yq'
    };
  },
  created() {
    this.mobile = localStorage.getItem("yhb_rememberPhone");
  },
  mounted() {
      if(this.$route.query.redirect) {
        let redirect = this.$route.query.redirect
         this.mark = redirect.substring(this.$route.query.redirect.indexOf('mark')).split('=')[1]
      }
      localStorage.setItem('yhb_mark', this.mark)
      this.$cookie.set('yhb_mark', this.mark)
  },
  methods: {
    // 标签栏切换
    tabsChange() {
      this.index = this.index === 1 ? 0 : 1;
    },
    // 获取验证码
    getCode() {
      if (!this.mobile) {
        Dialog.alert({
          message: "请输入手机号!"
        });
        return false;
      }
      this.$axios({
        url: "user/captcha",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        params: {
          mobile: this.mobile
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.codeDisabled = true;
          let TIME_COUNT = 60;
          let count = TIME_COUNT;
          this.count = "(" + TIME_COUNT + ")";
          this.timer = setInterval(() => {
            if (count > 1 && count <= TIME_COUNT) {
              count--;
              this.count = "(" + count + ")";
            } else {
              clearInterval(this.timer);
              this.timer = null;
              this.codeDisabled = false;
              this.count = "";
            }
          }, 1000);
        }
      });
    },
    //判断是否是微信登录
    isWxLogin() {
      return (
        window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !==
        -1
      );
    },
    // 微信推送
    wxLogin() {
      let params = {
        params: {
          userId: this.userId,
          loginType: 5,
          wechatMark: this.$wechatMark
        }
      };
      // 根据手机号获取openId
      this.$axios.post("weixin/get/openid", params).then(res => {
        if (res.data.code === 200) {
          if (res.data.data == null || res.data.data == "") {
            let params1 = {
              wechatMark: this.$wechatMark,
              callback: "https://yq.cg1717.com/wxCallback.html"
            };
            // 微信授权
            this.$axios
              .get("weixin/getCodeUrl", { params: params1 })
              .then(res => {
                window.location.href = res.data.data;
              });
          } else {
            this.$router.push("/preorder?mark=" + this.mark);
          }
        }
      });
    },
    // 登录按钮
    login() {
      let params;
      // 密码登录
      if (this.index == 1) {
        if (!this.mobile || !this.password) {
          Dialog.alert({
            message: "请输入完整信息！"
          });
          return false;
        }
        params = {
          params: {
            loginType: 5,
            mobile: this.mobile,
            password: this.password
          }
        };
        this.$axios.post("user/checkRegister", params).then(res => {
          if (res.data.code === 200) {
            Dialog.alert({
              message: "手机号" + this.mobile + "尚未注册，是否立即注册",
              closeOnClickOverlay: true
            }).then(() => {
              this.$router.push("register");
            });
          } else {
            this.$axios.post("auth/token", params).then(res => {
              if (res.data.code === 200) {
                let params = {
                  params: "TRANSPORT_WAY"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "transport",
                      list: d
                    });
                  }
                });
                params = {
                  params: "PACK_NAME_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "pack",
                      list: d
                    });
                  }
                });
                params = {
                  params: "PAY_MEANS_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "pay",
                      list: d
                    });
                  }
                });
                params = {
                  params: "DELIVERY_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "delivery",
                      list: d
                    });
                  }
                });
                params = {
                  params: "TRACKING_STATUS"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "status",
                      list: d
                    });
                  }
                });
                params = {
                  params: "PRODUCT_NAME_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "product",
                      list: d
                    });
                  }
                });
                let data = res.data.data;
                this.userId = data.accid;
                localStorage.setItem(
                  "yhb_token",
                  JSON.stringify({
                    token: data.token_type + " " + data.access_token
                  })
                );
                localStorage.setItem("yhb_phone", this.mobile);
                localStorage.setItem("yhb_userId", this.userId);
                localStorage.setItem("yhb_rememberPhone", this.mobile);
                this.$cookie.set(
                  "yhb_token",
                  JSON.stringify({
                    token: data.token_type + " " + data.access_token
                  })
                );
                this.$cookie.set("yhb_phone", this.mobile);
                this.$cookie.set("yhb_userId", this.userId);
                this.$store.commit("getToken");
                if (this.isWxLogin()) {
                  this.wxLogin();
                } else {
                  this.$router.push(this.$route.query.redirect || "/user");
                }
                // this.$router.push(this.$route.query.redirect || "/user");
              }
            });
          }
        });
      }
      // 验证码登录
      else {
        if (!this.mobile || !this.code) {
          Dialog.alert({
            message: "请输入完整信息！"
          });
          return false;
        }
        params = {
          params: {
            loginType: 5,
            mobile: this.mobile,
            code: this.code
          }
        };
        this.$axios.post("user/checkRegister", params).then(res => {
          if (res.data.code === 200) {
            Dialog.alert({
              message: "手机号" + this.mobile + "尚未注册，是否立即注册？",
              confirmButtonText: "注册并登录",
              closeOnClickOverlay: true
            }).then(() => {
              this.$axios.post("auth/code", params).then(res => {
                if (res.data.code === 200) {
                  let params = {
                    params: "TRANSPORT_WAY"
                  };
                  this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                      let d = res.data.data;
                      d.forEach(val => {
                        val.name = val.dictName;
                      });
                      this.$store.commit({
                        type: "getDict",
                        t: "transport",
                        list: d
                      });
                    }
                  });
                  params = {
                    params: "PACK_NAME_TYPE"
                  };
                  this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                      let d = res.data.data;
                      d.forEach(val => {
                        val.name = val.dictName;
                      });
                      this.$store.commit({
                        type: "getDict",
                        t: "pack",
                        list: d
                      });
                    }
                  });
                  params = {
                    params: "PAY_MEANS_TYPE"
                  };
                  this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                      let d = res.data.data;
                      d.forEach(val => {
                        val.name = val.dictName;
                      });
                      this.$store.commit({
                        type: "getDict",
                        t: "pay",
                        list: d
                      });
                    }
                  });
                  params = {
                    params: "DELIVERY_TYPE"
                  };
                  this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                      let d = res.data.data;
                      d.forEach(val => {
                        val.name = val.dictName;
                      });
                      this.$store.commit({
                        type: "getDict",
                        t: "delivery",
                        list: d
                      });
                    }
                  });
                  params = {
                    params: "TRACKING_STATUS"
                  };
                  this.$axios.post("dict/info", params).then(res => {
                    if (res.data.code === 200) {
                      let d = res.data.data;
                      d.forEach(val => {
                        val.name = val.dictName;
                      });
                      this.$store.commit({
                        type: "getDict",
                        t: "status",
                        list: d
                      });
                    }
                  });
                  let data = res.data.data;
                  this.userId = data.accid;
                  localStorage.setItem(
                    "yhb_token",
                    JSON.stringify({
                      token: data.token_type + " " + data.access_token
                    })
                  );
                  localStorage.setItem("yhb_phone", this.mobile);
                  localStorage.setItem("yhb_userId", this.userId);
                  localStorage.setItem("yhb_rememberPhone", this.mobile);
                  this.$cookie.set(
                    "yhb_token",
                    JSON.stringify({
                      token: data.token_type + " " + data.access_token
                    })
                  );
                  this.$cookie.set("yhb_phone", this.mobile);
                  this.$cookie.set("yhb_userId", this.userId);
                  this.$store.commit("getToken");
                  if (this.isWxLogin()) {
                    this.wxLogin();
                  } else {
                    this.$router.push(this.$route.query.redirect || "/user");
                  }
                  // this.$router.push(this.$route.query.redirect || "/user");
                }
              });
            });
          } else {
            this.$axios.post("auth/code", params).then(res => {
              if (res.data.code === 200) {
                let params = {
                  params: "TRANSPORT_WAY"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "transport",
                      list: d
                    });
                  }
                });
                params = {
                  params: "PACK_NAME_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "pack",
                      list: d
                    });
                  }
                });
                params = {
                  params: "PAY_MEANS_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "pay",
                      list: d
                    });
                  }
                });
                params = {
                  params: "DELIVERY_TYPE"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "delivery",
                      list: d
                    });
                  }
                });
                params = {
                  params: "TRACKING_STATUS"
                };
                this.$axios.post("dict/info", params).then(res => {
                  if (res.data.code === 200) {
                    let d = res.data.data;
                    d.forEach(val => {
                      val.name = val.dictName;
                    });
                    this.$store.commit({
                      type: "getDict",
                      t: "status",
                      list: d
                    });
                  }
                });
                let data = res.data.data;
                this.userId = data.accid;
                localStorage.setItem(
                  "yhb_token",
                  JSON.stringify({
                    token: data.token_type + " " + data.access_token
                  })
                );
                localStorage.setItem("yhb_phone", this.mobile);
                localStorage.setItem("yhb_userId", this.userId);
                localStorage.setItem("yhb_rememberPhone", this.mobile);
                this.$cookie.set(
                  "yhb_token",
                  JSON.stringify({
                    token: data.token_type + " " + data.access_token
                  })
                );
                this.$cookie.set("yhb_phone", this.mobile);
                this.$cookie.set("yhb_userId", this.userId);
                this.$store.commit("getToken");
                if (this.isWxLogin()) {
                  this.wxLogin();
                } else {
                  this.$router.push(this.$route.query.redirect || "/user");
                }
              }
            });
          }
        });
      }
    },
    // 跳转至注册
    toRegister() {
      this.$router.push("register");
    },
    // 跳转至忘记密码
    toForgot() {
      this.$router.push("forgot");
    }
  }
};
</script>

<style scoped lang="scss">
#login {
  .login-title {
    background-color: #fff;
    font-size: 0.45rem;
    text-align: center;
    padding: 0.425rem 0;
  }
  .btn {
    padding: 0 0.25rem;
    margin: 0.25rem 0;
    display: flex;
    justify-content: space-around;
    .van-button {
      flex: 1;
      margin: 0 0.25rem;
    }
  }
}
</style>
